export default "__VITE_ASSET__62e0a491__"